import { ImageCrop } from "@sphtech/dmg-design-system";

/**
 * Replaces CUE image placeholder URLs in table cell data with actual image sources
 * from the provided tableImages map.
 *
 * Input: 'some text with <img src="https://cue1.cue-staging.sphnet.com.sg:8080/webservice/escenic/content/12345">'
 * If tableImages map has { '12345': { src: 'https://stg.cassette.sphdigital.com.sg/image/hardwarezone/48e9e08463f074e8a060fc76c5d484a80b3461f4d33086eafdc21decd5cf4372' } }
 * Output: 'some text with <img src="https://stg.cassette.sphdigital.com.sg/image/hardwarezone/48e9e08463f074e8a060fc76c5d484a80b3461f4d33086eafdc21decd5cf4372">'
 *
 * https://cue1.cue-staging.sphnet.com.sg:8080/webservice/escenic/content/12345 only applies to HWZ during migration
 */
export const replaceTableImagePlaceholders = (
  data: string[][],
  tableImages: Map<string, ImageCrop>,
): string[][] => {
  const regexImagePlaceholder =
    /"https?:\/\/cue1.cue-(?:staging|prd).sphnet.com.sg:8080\/webservice\/escenic\/content\/(\d+?)"/;
  return data.map((row) => {
    if (!Array.isArray(row)) {
      return row;
    }
    return row.map((col) => {
      if (typeof col !== "string") {
        return col;
      }
      const matches = col.match(regexImagePlaceholder);
      if (matches && matches[1] && tableImages.has(matches[1])) {
        const imageSrc = tableImages.get(matches[1])?.src;
        if (imageSrc) {
          return col.replace(regexImagePlaceholder, `"${imageSrc}"`);
        }
      }
      return col;
    });
  });
};
